import type { SystemDefaultsInfoModel } from "../../../OpenApi/api";

export interface ISystemDefaultsStore {
	readonly systemDefaults: SystemDefaultsInfoModel;
}

export class SystemDefaultsStore implements ISystemDefaultsStore {
	public readonly systemDefaults: SystemDefaultsInfoModel;

	constructor(systemDefaults: SystemDefaultsInfoModel) {
		this.systemDefaults = systemDefaults;
	}
}
